var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace1Right(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1005.32 926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f88459;\n      }\n\n      .cls-2 {\n        fill: #d79db6;\n      }\n\n      .cls-3 {\n        fill: #fabdc6;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-skin-color {\n        fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n\n      .cls-6 {\n        fill: #42210b;\n      }\n\n      .cls-7 {\n        fill: #f44d41;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M343.96,0h266.26C800.06,0,954.18,154.12,954.18,343.96v104.95c0,263.31-213.78,477.09-477.09,477.09h0C213.78,926,0,712.22,0,448.91v-104.95C0,154.12,154.12,0,343.96,0Z",
    transform: "translate(954.18 926) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 675.37,
    cy: 463,
    r: 114.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M554.69,463c0-66.54,54.14-120.68,120.68-120.68,66.54,0,120.68,54.14,120.68,120.68s-54.14,120.68-120.68,120.68c-66.54,0-120.68-54.14-120.68-120.68ZM566.56,463c0,60,48.81,108.8,108.8,108.8s108.8-48.81,108.8-108.8-48.81-108.8-108.8-108.8-108.8,48.81-108.8,108.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M784.25,460.99c0,40.02-32.45,72.47-72.47,72.47-40.02,0-72.47-32.45-72.47-72.47,0-40.02,32.45-72.47,72.47-72.47,40.02,0,72.47,32.45,72.47,72.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M633.27,460.99c0-43.29,35.22-78.51,78.51-78.51,43.29,0,78.51,35.22,78.51,78.51s-35.22,78.51-78.51,78.51c-43.29,0-78.51-35.22-78.51-78.51ZM645.35,460.99c0,36.63,29.8,66.43,66.43,66.43,36.63,0,66.43-29.8,66.43-66.43,0-36.63-29.8-66.43-66.43-66.43-36.63,0-66.43,29.8-66.43,66.43Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M675.37,342.22c-66.6,0-120.78,54.18-120.78,120.78,0,9.57,1.15,18.87,3.27,27.8l224.45-83.86c-20.23-38.44-60.56-64.72-106.93-64.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "950.31 475.08 1005.32 647.52 895.31 647.52 950.31 475.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "949.42 477.88 949.42 647.52 895.31 647.52 949.42 477.88"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M769.04,739.12c12.74,10.1,25.67,15.75,38.53,16.83,12.7,1.05,31.9-1.4,57.08-7.32l1.82-.44c5.79-1.38,12.99-3.1,22.9-3.64.67-.04,1.34,0,2.01-.03,1.48-.06,2.96-.06,4.44-.06,1.48,0,2.96,0,4.44.06.67.03,1.34,0,2.01.03,3.92.21,7.41.61,10.57,1.1-4,7.37-8.25,14.59-12.76,21.62-.28-.01-.56-.04-.85-.05-1.14-.04-2.27-.05-3.41-.04-1.14,0-2.28,0-3.41.04-4.62.19-9.25.7-13.87,1.58-.29.06-.59.12-.88.18-2.37.47-4.73,1.01-7.09,1.67l-.02-.06-.7.17c-9.1,2.14-34.68,8.16-56.21,8.16-2.74,0-5.41-.1-7.98-.31-17.31-1.45-34.24-8.65-50.45-21.43-5.26-4.15-5.91-11.9-1.32-16.78,3.98-4.23,10.59-4.88,15.14-1.28Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 597.91,
    cy: 662.15,
    rx: 70.6,
    ry: 35.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-skin-color",
    cx: 274.35,
    cy: 586.58,
    r: 120.78
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace1Right);
export default __webpack_public_path__ + "static/media/face1-right.4b22f128938f495abf2050f26d3ddfc4.svg";
export { ForwardRef as ReactComponent };